import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse } from "../../../models/discount.model";

@Injectable({
  providedIn: 'root',
})

export class ApiDiscountService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
  ) { }

  getDiscountCode(
    siteId: number,
    code: string,
    token: string,
  ): Observable<CityParkingDiscountByCodeResponse> {
    console.log('this Token : ', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/Cityparking/CityParkingDiscountByCode';
    const params = new HttpParams().set('siteId', siteId).set('code', code);

    console.log(
      '📨 sent api discount code ',
      url,
      headers,
      'params',
      params.toString(),
    );
    return this.http.get<CityParkingDiscountByCodeResponse>(url, {
      headers,
      params,
    });
  }

}